import { complianceCheckOverrideAtom } from '../_graphql/mutationComplianceCheckOverride';
import { complianceHoldExtendAtom } from '../_graphql/mutationComplianceHoldExtend';
import { complianceHoldFlagPoliceAtom } from '../_graphql/mutationComplianceHoldFlagPolice';
import { complianceHoldReleaseAtom } from '../_graphql/mutationComplianceHoldRelease';
import { complianceChecksQueryAtom } from '../_graphql/queryComplianceChecks';
import { complianceHoldsQueryAtom } from '../_graphql/queryComplianceHolds';

import { $scaleTicketId } from './scaleTicketPro.state';

export const $complianceChecks = complianceChecksQueryAtom((get) => {
  const purchaseLoadId = get($scaleTicketId);
  return {
    variables: { purchaseLoadId: purchaseLoadId ?? '' },
    skip: !purchaseLoadId,
  };
});

export const $complianceHolds = complianceHoldsQueryAtom((get) => {
  const purchaseLoadId = get($scaleTicketId);
  return {
    variables: { purchaseLoadId: purchaseLoadId ?? '' },
    skip: !purchaseLoadId,
  };
});

export const $overrideComplianceCheck = complianceCheckOverrideAtom({
  onSuccess: (get) => {
    get($complianceChecks).refetch?.();
  },
});

export const $releaseComplianceHold = complianceHoldReleaseAtom({
  onSuccess: (get) => {
    get($complianceHolds).refetch?.();
  },
});

export const $extendComplianceHold = complianceHoldExtendAtom({
  onSuccess: (get) => {
    get($complianceHolds).refetch?.();
  },
});

export const $flagPoliceComplianceHold = complianceHoldFlagPoliceAtom({
  onSuccess: (get) => {
    get($complianceHolds).refetch?.();
  },
});
